import _ from "lodash";

import wordlist_en from "../data/wordlist_en.json";
import wordlist_jp from "../data/wordlist_jp.json";
import musicOrder from "../data/music_order.json";
import musicInfo from "../data/musicinfo.json";
// import musicAttributes from "../data/music_attribute.json";

const getSongTitleInfoByID = (songId, language) => {
    const wordlist = language === "jp" ? wordlist_jp : wordlist_en;
    const id = songId ? songId.replace("song_", "") : null;
    const songTitleEntry = _.find(wordlist.items, { key: `song_${id}` });
    const songSubTitleEntry = _.find(wordlist.items, { key: `song_sub_${id}` });

    if (songTitleEntry) {
        return {
            title: songTitleEntry.japaneseText,
            subtitle: songSubTitleEntry.japaneseText,
        };
    }
};

const getSongGenreBySongID = (songId) => {
    const id = songId ? songId.replace("song_", "") : null;

    let songGenreEntry = _.find(musicOrder.items, { id: id });

    if (songGenreEntry) {
        switch (songGenreEntry.genreNo) {
            case 0:
                return {
                    title: "Pop",
                    color: "#42c0d2",
                    id: 0,
                };
            case 1:
                return {
                    title: "Anime",
                    color: "#ff90d3",
                    id: 1,
                };
            case 2:
                return {
                    title: "Kids",
                    color: "#fec000",
                    id: 2,
                };
            case 3:
                return {
                    title: "Vocaloid",
                    color: "#bababb",
                    id: 3,
                };
            case 4:
                return {
                    title: "Game Music",
                    color: "#cc8aea",
                    id: 4,
                };
            case 5:
                return {
                    title: "Namco Original",
                    color: "#ff7027",
                    id: 5,
                };
            case 7:
                return {
                    title: "Variety",
                    color: "#1dc83b",
                    id: 7,
                };
            case 8:
                return {
                    title: "Classical",
                    color: "#bfa356",
                    id: 8,
                };
            default:
                return null;
        }
    }
};

const getSongStarsBySongID = (record) => {
    const songId = record.song_id;
    const id = songId ? songId.replace("song_", "") : null;

    let songStarsEntry = _.find(musicInfo.items, { id: id });

    switch (record.difficulty) {
        case 1:
            return songStarsEntry.starEasy;
        case 2:
            return songStarsEntry.starNormal;
        case 3:
            return songStarsEntry.starHard;
        case 4:
            return songStarsEntry.starMania;
        case 5:
            return songStarsEntry.starUra;
        default:
            return null;
    }
};

const getSongUniqueIdBySongID = (songId) => {
    const id = songId ? songId.replace("song_", "") : null;
    let songUniqueIdEntry = _.find(musicInfo.items, { id: id });

    return songUniqueIdEntry.uniqueId;
};

const getSongIDBySongUniqueID = (songUniqueId) => {
    let songIdEntry = _.find(musicInfo.items, { uniqueId: songUniqueId });

    return songIdEntry ? songIdEntry.id : null;
};

const getAllSongData = () => {
    let songData = [];

    for (let i = 0; i < musicInfo.items.length; i++) {
        let song = {
            id: musicInfo.items[i].id,
            title: getSongTitleInfoByID(musicInfo.items[i].id, "en")?.title,
            subtitle: getSongTitleInfoByID(musicInfo.items[i].id, "en")
                ?.subtitle,
            title_jp: getSongTitleInfoByID(musicInfo.items[i].id, "jp")?.title,
            subtitle_jp: getSongTitleInfoByID(musicInfo.items[i].id, "jp")
                ?.title,
            genre: getSongGenreBySongID(musicInfo.items[i].id),
            uniqueId: musicInfo.items[i].uniqueId,
        };

        if (song.genre) {
            songData.push(song);
        } else {
            console.warn(`${song.id} is missing genreNo. Skipped.`);
        }
    }

    return songData;
};

export {
    getSongTitleInfoByID,
    getSongGenreBySongID,
    getSongStarsBySongID,
    getSongUniqueIdBySongID,
    getSongIDBySongUniqueID,
    getAllSongData,
};
